module.exports = __webpack_public_path__ + "puxiimg2.png?c0673c75fe745939839323947d1812b2";